
import React from "react";
import "./CustomTab.css"; 

const CustomTab = ({  label, isActive, onClick}) => {
  return (
    
          <button
      className={isActive ? "tab active" : "tab"}
      onClick={onClick}
          >
      {label}
    </button>
      
  );
};

export default CustomTab;
